<template>
	<div id="app">
		<headact v-show="!$route.meta.nohead"></headact>
		<keep-alive :include="caches_page">
				<router-view > </router-view>
		</keep-alive>
		<footact v-show="!$route.meta.nofoot"></footact>
	</div>
</template>

<script>
	import headact from './components/head.vue'
	import footact from './components/foot.vue'
	export default {
		name: 'app',
		components: {
			headact,
			footact
		},
		computed:{
			caches_page(){
				return this.$store.state.cache_Page
			}
		},
		created() {
		}

	}
</script>

<style>
	.rich-table {
	  border-collapse: collapse;
	  margin: 10px 0;
	}
	
	.rich-table th, .rich-table td {
	  border: 1px solid #ccc;
	  padding: 5px;
	}
	
	.rich-table th {
	  background-color: #f1f1f1;
	  font-weight: bold;
	}
	@import url('assets/icons/font_4092295_mob0r9kel7/iconfont.css');
	@import url('assets/css/person.css');
	/* @import url('.element-ui/lib/theme-chalk/index.css'); */
	#app {
		font-family: 'Avenir', Helvetica, Arial, sans-serif;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
	}
</style>